import styled, { css } from 'styled-components';
import { pxToRem } from '../../../design-tokens/style-utilities';
/**
 * BlockList
 */
export const blockListStyles = ({ theme }) => css `
	display: flex;
	flex-direction: column;
	gap: ${pxToRem(theme.spacing['300'])};
	margin: 0;
	padding: 0;
	max-width: none;
	list-style: none;

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.xl)}) {
		gap: ${pxToRem(theme.spacing['400'])};
	}
`;
export const StyledBlockList = styled.ul `
	${blockListStyles}
`;
